// FIXME: update to use a const object instead of a typescript enum
// eslint-disable-next-line @vowkey/platform/no-enums
export enum EmergencyAccessType {
  View = 0,
  Takeover = 1,
}
